import CourseProgressNextLesson from '@/components/dashboard/student/courseProgressNextLesson/CourseProgressNextLesson';
import KlassLeaderBoard from '@/components/dashboard/student/leaderboard/KlassLeaderBoard';
import LessonProgressCollection from '@/components/dashboard/student/lessonProgressCollection/LessonProgressCollection';
import StudentProgressStatsCollection from '@/components/dashboard/student/statsCollection/StudentProgressStatsCollection';
import Text from '@/components/ui/custom/dataDisplay/Text';
import { Wellcome } from '@/components/ui/custom/Wellcome';
import useAuth from '@/data/hook/useAuth';
import { useExtraCourseSelection } from '@/data/hook/useExtraCourseSelection';
import useStudentContext from '@/data/hook/useStudentContext';
import LoadingView from '@/pages/courses/LoadingView';
import { GuestPage } from '@/pages/guest/GuestPage';
import { getErrorMessage } from '@/utils/getErrorMessage';

export default function StudentDashboardView() {
  const { user } = useAuth();
  const {
    currentProgress,
    klass,
    dashboardStats,
    loadingDashboard,
    dashboardStatsError,
    otherCoursesStats,
    selectProgress,
  } = useStudentContext();

  useExtraCourseSelection({
    currentProgress,
    otherCoursesStats,
    selectProgress,
  });

  if (!user) return null;

  if (loadingDashboard) return <LoadingView />;

  if (dashboardStatsError)
    return (
      <Text
        text={getErrorMessage(dashboardStatsError)}
        format="rubik-500"
        className="text-primary"
      />
    );

  if (!dashboardStats || !currentProgress) return <GuestPage user={user} />;

  return (
    <main className="flex flex-col gap-4">
      <Wellcome userType={user.userType} firstName={user.firstName} />

      <div className="flex flex-col xl:flex-row gap-5">
        <div className="flex flex-col gap-4 self-start w-full">
          <CourseProgressNextLesson
            courseProgrss={currentProgress}
            klass={klass}
          />
          <StudentProgressStatsCollection
            statsCollection={dashboardStats.progresses}
          />
          <LessonProgressCollection
            courseProgressId={currentProgress.id}
            slugCourseName={currentProgress.coursePath.slug}
            klassId={currentProgress.klassId}
            enrollmentStatus={currentProgress.enrollmentStatus}
          />
        </div>

        <KlassLeaderBoard klass={klass} />
      </div>
    </main>
  );
}
